'use client'

import { motion } from 'framer-motion'
import { Palette } from 'lucide-react'
import { CORES_PRESET } from '../utilitarios'

interface StepBrandingProps {
  coresSelecionadas: string[]
  toggleColor: (cor: string) => void
  urlReferencia: string
  setUrlReferencia: (valor: string) => void
  onSubmit: (temLogo: boolean) => void
  onBack: () => void
}

export function StepBranding({ coresSelecionadas, toggleColor, urlReferencia, setUrlReferencia, onSubmit, onBack }: StepBrandingProps) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-full max-w-md mx-auto">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-4 sm:mb-6">
        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg shadow-purple-500/30">
          <Palette size={24} strokeWidth={1.5} className="text-white" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-indigo-950 dark:text-white mb-2">Sobre sua marca</h2>
        <p className="text-indigo-950/50 dark:text-white/50 text-sm">Nos ajude a entender seu estilo</p>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="space-y-4">
        <div>
          <label className="text-sm text-indigo-950/60 dark:text-white/60 mb-2 block">Cores da marca (opcional)</label>
          <div className="flex flex-wrap gap-2">
            {CORES_PRESET.map((color) => {
              const isSelected = coresSelecionadas.includes(color)
              return (
                <button key={color} onClick={() => toggleColor(color)} className={`w-11 h-11 rounded-lg border-2 transition-all ${isSelected ? 'border-purple-500 scale-110' : 'border-transparent hover:scale-105'}`} style={{ backgroundColor: color }} />
              )
            })}
          </div>
          {coresSelecionadas.length > 0 && <p className="text-xs text-indigo-950/40 dark:text-white/40 mt-2">{coresSelecionadas.length} cores selecionadas</p>}
        </div>
        <div>
          <label className="text-sm text-indigo-950/60 dark:text-white/60 mb-2 block">Site de referencia (opcional)</label>
          <input type="url" value={urlReferencia} onChange={(e) => setUrlReferencia(e.target.value)} placeholder="www.exemplo.com" className="w-full px-4 py-3 rounded-xl bg-white/85 dark:bg-white/5 border border-purple-500/20 dark:border-white/10 text-indigo-950 dark:text-white placeholder:text-indigo-950/30 dark:placeholder:text-white/30 outline-none transition-all focus:border-purple-500/50" />
        </div>
        <div className="flex gap-2 pt-2">
          <button onClick={() => onSubmit(false)} className="flex-1 py-3.5 rounded-full font-medium text-sm border border-purple-500/20 dark:border-white/10 text-indigo-950/70 dark:text-white/70 hover:bg-white/85 dark:bg-white/5 transition-all">Nao tenho logo</button>
          <button onClick={() => onSubmit(true)} className="flex-1 py-3.5 rounded-full font-medium text-sm bg-purple-600 hover:bg-purple-500 text-white shadow-lg shadow-purple-600/25 transition-all">Tenho logo</button>
        </div>
      </motion.div>
      <motion.button initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }} onClick={onBack} className="mt-4 w-full text-center text-sm text-indigo-950/40 dark:text-white/40 hover:text-indigo-950/60 dark:text-white/60 transition-colors">&larr; Voltar</motion.button>
    </motion.div>
  )
}
